import { render } from "./TrustedPartners.vue?vue&type=template&id=361ac8b8&scoped=true"
import script from "./TrustedPartners.vue?vue&type=script&lang=js"
export * from "./TrustedPartners.vue?vue&type=script&lang=js"

import "./TrustedPartners.vue?vue&type=style&index=0&id=361ac8b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-361ac8b8"]])

export default __exports__